<template>
    <div class="patient_info_value grid-item c_selector patient_search_select">
        <v-select
            :key="item.values.seqPatient"
            v-model="item.values"
            :options="item.keyRange"
            :get-option-label="option =>`${option.patientName} (${option.patientEmail})`"
        >
          <template #search="{ attributes, events }">
            <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                style="margin-right: 40px;"
            />
          </template>
          <template #option="{ patientName, patientInfoBirth, patientInfoGender, no, patientEmail }">
               <div
                   style="width: 100%; height: 100%;"
                   v-tooltip="`${patientName ? patientName : ''}<br/>${patientEmail? patientEmail : ''}`"
               >
                  <div class="auto_user_area">
                      <div class="user_info">
                          <span
                              class="user_name"
                              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;display: block;"
                          >
                            {{ patientName ? patientName : '' }}
                          </span>
                          <p>
                              {{ calculatedAge(patientInfoBirth) }} /
                              {{ computedGender(patientInfoGender) }}
                          </p>
                      </div>
                  </div>
                  <div class="auto_add_area">
                      <span
                          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;display: block;"
                      >
                        {{ patientEmail? patientEmail : '' }}
                      </span>
                  </div>
               </div>
            </template>
          <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
        </v-select>
    </div>
</template>
<script>
import {
  GENDER_TRANS,
} from "@/enum/lib";

export default {
  name: 'selectBox',
  props: [
    'item',
  ],
  data() {
    return {}
  },
  methods: {
    calculatedAge(patientInfoBirth) {
      let birthTxt = '';

      if (!patientInfoBirth)
        birthTxt = this.$t('unset');
      else
        birthTxt = `${this.moment().diff(this.moment(patientInfoBirth), 'years')} ${this.$t('unit.years_old')}`;

      return birthTxt;
    },
    computedGender(patientInfoGender) {
      return patientInfoGender ? this.$t(GENDER_TRANS[patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans);
    }
  }
}
</script>
<style lang="scss">
.patient_search_select {
  .vs__dropdown-toggle:focus-within {
    border: 1px solid var(--blue70);
  }

  .vs__dropdown-toggle:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>